import { useState, useEffect } from "react";
import Loader from "components/Loader";
import CommonResultTable from "components/Tables/CommonResultTable";
import { submitKeywordAnalysisRequest } from "services/buddyXApiHubService";
import HelpCard from "components/Cards/HelpCard";
import { Button, Col, Form } from "react-bootstrap";
import Validator from "utils/Validator";
import classNames from "classnames";
import { css } from "aphrodite";
import pageStyles from "styles/pageStyles";

export default function Page() {
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isResultGot, setIsResultGot] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [webSite, setWebSite] = useState("");
  const [showSearchItem, setShowSearchItem] = useState("");

  const [formData, setFormData] = useState({
    keyword: [],
    domainLink: "",
  });
  const firstLevelTopic = "SEO";
  const secoundLevelTopic = "Ranking";
  const thirdLevelTopic = "Domain Ranking";

  const columnNames = {
    keyword_position: "Keyword position",
    page_url: "Page URL",
  };

  const [errors, setErrors] = useState({ keyword: "", domainLink: "" });
  const [data, setData] = useState([
    {
      keyword_position: 1,
      page_url: "https://example.com/keyword-optimization",
    },
    {
      keyword_position: 2,
      page_url: "https://example.com/seo-best-practices",
    },
    {
      keyword_position: 3,
      page_url: "https://example.com/content-marketing",
    },
    {
      keyword_position: 4,
      page_url: "https://example.com/link-building-strategies",
    },
    {
      keyword_position: 5,
      page_url: "https://example.com/social-media-strategies",
    },
    {
      keyword_position: 6,
      page_url: "https://example.com/email-marketing-tips",
    },
    {
      keyword_position: 7,
      page_url: "https://example.com/paid-advertising",
    },
    {
      keyword_position: 8,
      page_url: "https://example.com/analytics-and-measurement",
    },
    {
      keyword_position: 9,
      page_url: "https://example.com/web-development",
    },
    {
      keyword_position: 10,
      page_url: "https://example.com/user-experience-design",
    },
  ]);

  const handleWebSiteChange = (e) => {
    setWebSite(e.target.value);
  };
  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (
      name === "keyword" &&
      !Validator.validateRequired(keyword, Validator.validateSingleKeyword)
    ) {
      error = "Please enter keywords";
    } else if (
      name === "webSite" &&
      !Validator.validateOptional(value, Validator.validateUrl)
    ) {
      error = "Invalid URL";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleReset = () => {
    setData([]);
    setShowSearchItem("");
    setIsResultGot(false);
    setKeyword("");
    setWebSite("");
    setErrors({ keyword: "" });
  };

  const handleSubmit = async () => {
    try {
      // setIsLoading(true);
      console.log(formData);
      // const result = await submitKeywordAnalysisRequest(formData,"domain_ranking" ,handleInsufficientCredits);
      // console.log("Data submitted successfully:", result);
      // setData(result);
      setShowSearchItem(formData.keyword);
      setIsResultGot(true);
    } catch (error) {
      console.error("Submission error:", error);
      setIsResultGot(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    let isValid =
      Validator.validateOptional(webSite, Validator.validateUrl) &&
      Validator.validateRequired(keyword, Validator.validateSingleKeyword);
    if (isValid) {
      setFormData({
        keyword: [keyword],
        domainLink: webSite,
      });
    }
    setIsFormValid(isValid);
  }, [keyword, webSite]);

  return (
    <div className={classNames("container-fluid", css(pageStyles.container))}>
      <h1 className=" d-flex fw-normal justify-content-start align-items-center fw-bold">
        {secoundLevelTopic}
      </h1>
      <p className="fw-normal justify-content-start align-items-center">
        {firstLevelTopic} / {secoundLevelTopic} / <b>{thirdLevelTopic}</b>
      </p>
      <p className="fw-normal justify-content-start align-items-center">
        Keyword ranking analysis at the domain level aggregates performance
        across an entire website, offering a holistic view of organic search
        health, competitive benchmarking, and strategic gaps that influence
        overall traffic and revenue attribution. In the 2025 search paradigm,
        with advanced AI orchestration and cross-device personalization,
        domain-level tracking can identify 30-50% untapped opportunities through
        pattern recognition in ranking volatility, ensuring alignment with core
        web vitals and E-E-A-T standards to fortify long-term authority and
        mitigate broad-scale penalties from algorithm updates.
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-10 col-sm-10">
          <HelpCard
            topic={"How To Use"}
            description={`${'"'}Article Headlines ${'"'} helps you craft compelling, optimised titles for your articles, boosting engagement and driving more traffic by improving click-through rates and search visibility.`}
            image={"/icon/pin.svg"}
          />
        </div>
      </div>
      <div className="p-2 mb-2 rounded">
        <div className="d-flex fw-bold mb-0">Find Your Domain Rankings</div>
        <div className="row mb-2 align-items-end">
          <div className="mb-2">
            <p className="fw-normal justify-content-start align-items-center">
              Enter a keyword and website to analyze domain rankings.
            </p>
            <Form.Group>
              <div className="d-flex mt-2">
                <Col sm={4} className="me-2">
                  <Form.Control
                    type="text"
                    name="keyword"
                    placeholder="Enter keyword"
                    value={keyword}
                    onChange={handleKeywordChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.keyword}
                    required
                    className="px-2"
                  />
                </Col>
                <Col sm={4} className="me-2">
                  <Form.Control
                    type="text"
                    name="webSite"
                    placeholder="Enter Website"
                    value={webSite}
                    onChange={handleWebSiteChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors.webSite}
                    className="px-2"
                  />
                </Col>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-2 me-1">
                  <div className="d-flex justify-content-start align-items-end">
                    <Button
                      variant="dark"
                      className="me-1"
                      onClick={handleSubmit}
                      disabled={!isFormValid}
                    >
                      Search
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="me-1"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </div>

      {showSearchItem !== "" && (
        <div>
          <p className="d-flex fw-bold mb-0">
            Keyword for
            <span className="search-item">&nbsp;"{showSearchItem}"</span>
          </p>
          <p className="text-muted">
            The first 5 {secoundLevelTopic} out of 20
          </p>
        </div>
      )}

      {isLoading && <Loader />}

      {data.length !== 0 && (
        <CommonResultTable data={data} columnNames={columnNames} />
      )}
    </div>
  );
}
